module.exports = __webpack_public_path__ + "media/stylesheets/images/icon/aside_coupon_mobile-24f81cace997561766d35e9caa3aeb6a.svg";